var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_1334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 7.45027C16 5.99949 14.9437 4.79096 13.5599 4.55286V2.42352C13.5599 1.91208 13.2652 1.46049 12.7717 1.21552C12.306 0.984394 11.7718 0.984394 11.3061 1.21552L4.83275 4.42852C4.76244 4.23749 4.57937 4.10099 4.36394 4.10099H2.43197C1.09097 4.10099 0 5.19196 0 6.53296V8.36758C0 9.69583 1.0705 10.7781 2.39397 10.7986V13.7225C2.39397 14.4035 2.948 14.9575 3.62897 14.9575C4.30994 14.9575 4.86394 14.4035 4.86394 13.7225V10.4875L11.3061 13.685C11.539 13.8006 11.7889 13.8584 12.0389 13.8584C12.2888 13.8584 12.5388 13.8006 12.7717 13.685C13.2652 13.4401 13.5599 12.9885 13.5599 12.477V10.3477C14.9437 10.1096 16 8.90105 16 7.45027ZM1 8.36758V6.53296C1 5.74336 1.64237 5.10099 2.43197 5.10099H3.86394V9.79955H2.43197C1.64237 9.79955 1 9.15718 1 8.36758ZM3.62894 13.9575C3.50156 13.9575 3.39394 13.8499 3.39394 13.7225V10.7996H3.86391V13.7225C3.86394 13.8499 3.75634 13.9575 3.62894 13.9575ZM12.5599 12.477C12.5599 12.6076 12.4816 12.7126 12.3271 12.7893C12.1412 12.8815 11.9365 12.8816 11.7507 12.7893L4.86394 9.37108V5.52943L11.7507 2.11124C11.9365 2.01899 12.1412 2.01899 12.3271 2.11124C12.4815 2.18793 12.5599 2.29299 12.5599 2.42352V12.477ZM13.5599 9.32474V5.57577C14.3881 5.79689 15 6.55333 15 7.45027C15 8.34721 14.3881 9.10361 13.5599 9.32474Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMike);
export default __webpack_public_path__ + "static/media/mike.50d7858acce0530c2765d9531b2dd7ee.svg";
export { ForwardRef as ReactComponent };